import React from "react";
import { makeStyles, Typography, Icon, Box, Button, Link, Card, CardHeader, Grid, CardContent, CardActions, } from "@material-ui/core";
import LinkWithArrow from "../LinkWithArrow";
import { TeaserEnum } from "../../enums";
const useStyles = makeStyles((theme) => ({
    linkWithIcon: (props) => ({
        display: "flex",
        alignItems: "center",
        color: props.data?.fullBackgroundVersion.value
            ? theme?.cardInformationBlock?.darkModeTextColor ||
                theme?.colorCard?.background ||
                theme.palette?.primary?.contrastText
            : theme.colorCard?.primary || theme.palette?.primary?.main,
    }),
    tetriaryButton: (props) => ({
        textDecoration: theme.tetriaryLink?.underlined ? "underline" : "none",
        color: props.data?.fullBackgroundVersion?.value
            ? theme?.cardInformationBlock?.darkModeTextColor ||
                theme?.colorCard?.background ||
                theme.palette?.primary?.contrastText
            : theme.colorCard?.primary || theme.palette?.primary?.main,
        ...theme.customStyling?.global?.tetriaryButton,
    }),
    icon: {
        fontSize: "1rem",
        width: 40,
        height: 40,
        marginTop: "auto",
        marginBottom: "auto",
    },
    iconImage: {
        width: 40,
        marginTop: 5,
    },
    headerwrapper: (props) => ({
        display: "flex",
        flexDirection: "row",
        backgroundColor: theme?.cardInformationBlock?.backgroundColor ||
            theme.colorCard?.primary ||
            theme.palette?.primary?.main,
        color: theme?.cardInformationBlock?.darkModeTextColor ||
            theme.colorCard?.background ||
            theme.palette?.primary?.contrastText,
        alignContent: "center",
        height: props.data?.fullBackgroundVersion?.value ? 88 : 72,
        paddingLeft: 24,
        padding: 0,
        ...theme.customStyling?.CardInformationBlock?.headerwrapper,
    }),
    link: (props) => ({
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 0,
        paddingBottom: 40,
        justifyContent: props.data.icon?.value?.url ? "start" : "center",
        "& a": {
            color: props.data?.fullBackgroundVersion?.value
                ? theme?.cardInformationBlock?.darkModeTextColor ||
                    theme?.colorCard?.background ||
                    theme.palette?.primary?.contrastText
                : theme.colorCard?.primary || theme.palette?.primary?.main,
            "&:hover": {
                color: props.data?.fullBackgroundVersion?.value
                    ? theme?.cardInformationBlock?.darkModeHover ||
                        theme?.customStyling?.CardInformationBlock?.darkModeHover ||
                        theme.colorCard?.tetriaryHover ||
                        theme.palette.primary.main
                    : theme.colorCard?.tetriaryHover || theme.palette.primary.main,
            },
        },
        "& .MuiButton-outlined": {
            borderColor: props.data?.fullBackgroundVersion?.value
                ? theme?.cardInformationBlock?.darkModeTextColor ||
                    theme?.colorCard?.background ||
                    theme.palette?.primary?.contrastText
                : theme.colorCard?.primary || theme.palette?.primary?.main,
        },
        ...theme.customStyling?.CardInformationBlock?.link,
    }),
    header: {
        color: "#FFFFFF",
        marginTop: "auto",
        marginBottom: "auto",
        ...theme.customStyling?.CardInformationBlock?.header,
    },
    innerBody: (props) => ({
        "& p": {
            marginTop: 0,
            paddingBottom: 0,
            marginBottom: 0,
        },
        color: props.data?.fullBackgroundVersion.value
            ? theme?.cardInformationBlock?.darkModeTextColor ||
                theme?.colorCard?.background ||
                theme.palette?.primary?.contrastText
            : theme?.colorCard?.bodyText || theme?.palette?.text?.primary,
        ...theme.customStyling?.CardInformationBlock?.innerBody,
    }),
    cardText: {
        marginBottom: 0,
        paddingBottom: 0,
    },
    cardLink: (props) => ({
        justifySelf: "end",
        marginTop: "auto",
        ...(props.data.fullBackgroundVersion.value
            ? theme.customStyling?.CardInformationBlock?.cardLinkInversed
            : theme.customStyling?.CardInformationBlock?.cardLink),
        "& a": {
            ...theme.customStyling?.CardInformationBlock?.cardLink?.linkWithIcon,
        },
        "& svg": {
            ...theme.customStyling?.CardInformationBlock?.cardLink?.icon,
        }
    }),
    cardContent: (props) => ({
        padding: 24,
        paddingBottom: 32,
        paddingTop: props.data?.fullBackgroundVersion?.value ? 0 : 24,
        ...theme.customStyling?.CardInformationBlock?.cardContent,
    }),
    teaserGrid: (props) => ({
        display: "flex",
        flexDirection: "column",
        height: `calc(100% - ${props.data?.fullBackgroundVersion?.value ? "88px" : "72px"})`,
        backgroundColor: props.data.fullBackgroundVersion.value
            ? theme?.cardInformationBlock?.backgroundColor ||
                theme.colorCard?.primary ||
                theme.palette?.primary?.main
            : "transprent",
        ...(props.data.fullBackgroundVersion.value
            ? theme.customStyling?.CardInformationBlock?.teaserGridInversed
            : theme.customStyling?.CardInformationBlock?.teaserGrid),
    }),
    headerwithouticon: {
        color: "#FFFFFF",
        margin: "auto",
    },
    rootWrap: (props) => ({
        maxWidth: 400,
        width: "100%",
        textAlign: props.data.icon?.value?.url ? "start" : "center",
    }),
    root: {
        maxWidth: "100vh",
        borderRadius: 0,
        boxShadow: "none",
        marginTop: 0,
        height: "100%",
        border: `1px solid ${theme.colorCard?.dividerLine || theme.palette?.divider}`,
        background: theme.colorCard?.background || theme.palette?.background?.default,
        ...theme.customStyling?.CardInformationBlock?.root,
    },
    button: {
        ...theme.customStyling?.CardInformationBlock?.button,
    },
}));
export const CardInformationBlock = (props) => {
    const classes = useStyles(props);
    function getLinkArea(teaser) {
        switch (teaser) {
            case TeaserEnum.Link:
                return (React.createElement(Link, { href: props.data.link.value, className: classes.tetriaryButton }, props.data.bottomLinkText.value));
            case TeaserEnum.Button:
                return (React.createElement(Button, { variant: "outlined", href: props.data.link.value, className: classes.button }, props.data.bottomLinkText.value));
            case TeaserEnum.LinkWithIcon:
                return (React.createElement(LinkWithArrow, { link: {
                        url: props.data.link.value,
                        text: props.data.bottomLinkText.value,
                    } }));
            case TeaserEnum.LinkWithArrow:
                return (React.createElement(LinkWithArrow, { link: {
                        url: props.data.link.value,
                        text: props.data.bottomLinkText.value,
                    } }));
        }
    }
    return (React.createElement(Box, { className: classes.rootWrap },
        React.createElement(Card, { className: classes.root },
            React.createElement(CardHeader, Object.assign({ className: classes.headerwrapper }, (props.data.anchor && { id: props.data.anchor?.value }), { avatar: props.data.icon.value?.url && (React.createElement(Icon, { className: classes.icon },
                    React.createElement("img", { src: props.data.icon?.value?.url, 
                        // alt={props.data.altTextMoImage?.value}
                        alt: "", className: classes.iconImage }))), title: React.createElement(Typography, { variant: "h3", component: "h3", className: classes.header, dangerouslySetInnerHTML: { __html: props.data.header.value } }) })),
            React.createElement(Grid, { container: true, className: classes.teaserGrid },
                React.createElement(Grid, { item: true, className: classes.cardText },
                    React.createElement(CardContent, { className: classes.cardContent },
                        React.createElement(Typography, { variant: "body1", color: "textSecondary", component: "p", className: classes.innerBody, dangerouslySetInnerHTML: { __html: props.data.text.value } }))),
                React.createElement(Grid, { item: true, className: classes.cardLink },
                    React.createElement(CardActions, { className: classes.link }, getLinkArea(props.data.bottomLinkType.value)))))));
};
export default CardInformationBlock;
